import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import { createIntl, IntlProvider } from 'react-intl';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../contexts/language';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import { FavoriteButton } from '../../atoms/FavoriteButton';

const languages = {
  ar,
  en
};


export const FavoriteAndAvailability = ({ onToggleFavorite, favorite, stockAvailability }) => {
  const localeConfig = React.useContext(LocaleContext);

  const intl = createIntl({
    locale: localeConfig.lang,
    messages: languages[localeConfig?.lang] || languages.en
  });
  return (
    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
      <Stack
        direction={'row'}
        sx={{ position: 'absolute', top: '0px', alignItems: 'center', width: '100%', m: 0 }}
      >
        <Box
          sx={{ m: 1, zIndex:3 }}
        >
          {stockAvailability === 'UNKNOWN' && (
            <Chip
            // color={'primary'}
              icon={<ContactSupportIcon />}
              label={intl.formatMessage({
                id: 'FavoriteAndAvailability.EnquireForAvailability',
                defaultMessage: 'Enquire for Availability'
              })}
              sx={{
                backgroundColor:'#ffffffc0',

              }}
            />
          )}
          {stockAvailability === 'IN_STOCK' && (
            <Chip
              color={'success'}
              icon={<CheckCircleIcon />}
              label={intl.formatMessage({
                id: 'FavoriteAndAvailability.IN_STOCK',
                defaultMessage: 'In Stock'
              })}
            />
          )}
          {stockAvailability === 'WAIT_LIST' && (
            <Chip
              color={'warning'}
              icon={<PlaylistAddCheckCircleIcon />}
              label={intl.formatMessage({
                id: 'FavoriteAndAvailability.WAIT_LIST',
                defaultMessage: 'Pre-Order'
              })}
            />
          )}
          {stockAvailability === 'NOT_AVAILABLE' && (
            <Chip
              color={'error'}
              icon={<CancelIcon />}
              label={intl.formatMessage({
                id: 'FavoriteAndAvailability.NOT_AVAILABLE',
                defaultMessage: 'Out Of Stock'
              })}
            />
          )}
        </Box>
        <Box
          sx={{ m: 1, marginLeft: 'auto' }}
        >
          <FavoriteButton sx={{ alignItems: 'flex-end' }} onToggleFavorite={  onToggleFavorite} favorite={favorite}/>
        </Box>
      </Stack>

    </IntlProvider>
  );
};
FavoriteAndAvailability.propTypes = {
  favorite:PropTypes.bool,
  onToggleFavorite:PropTypes.func,
  stockAvailability: PropTypes.oneOf(['UNKNOWN', 'IN_STOCK','WAIT_LIST','NOT_AVAILABLE'])
};
FavoriteAndAvailability.defaultProps={
  favorite:false,
  stockAvailability:'UNKNOWN'
};

export default FavoriteAndAvailability;